import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  SwitchProps,
  Text,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useUpdateExclusiveDealApi } from 'apis/exclusive-deals';

export interface IExclusiveDealActivationSwitchCell extends SwitchProps {
  dealId: number;
  isActive: boolean;
}

export const ExclusiveDealActivationSwitch = ({ dealId, isActive, ...rest }: IExclusiveDealActivationSwitchCell) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: updateDeal, isLoading } = useUpdateExclusiveDealApi();

  const handleActivate = () => {
    const variables = {
      dealId,
      body: {
        isActive: !isActive,
      },
    };

    updateDeal(variables, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <>
      <FormControl display='flex' alignItems='center'>
        <Switch id={`active-deal-${dealId}`} onChange={onOpen} isChecked={isActive} {...rest} />
        <FormLabel htmlFor={`active-deal-${dealId}`} mb='0' ms='sm' userSelect='none' fontWeight='normal' fontSize='sm'>
          {isActive ? 'Active' : 'Inactive'}
        </FormLabel>
      </FormControl>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isActive ? 'Deactivate' : 'Activate'} exclusive deal!</ModalHeader>

          <ModalBody>
            {isActive && <Text>Are you sure you want to deactivate this exclusive deal?</Text>}
            {!isActive && <Text>Are you sure you want to activate this exclusive deal?</Text>}
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='solid' colorScheme='red' onClick={handleActivate} isLoading={isLoading}>
                {isActive ? 'Deactivate' : 'Activate'}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
